// extracted by mini-css-extract-plugin
module.exports = {"input":"input-area_input__o4oGs"};